import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  BlockOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import { Card, Col, Row } from "antd";
import useCollectionsCardsKpisData from "../../hooks/useCollectionsCardsKpisData";
import useZonesCardsKpisData from "../../hooks/useZonesCardsKpisData";
import {
  HOME_DASHBOARD_COLLECTIONS_CARDS_KPIS,
  HOME_DASHBOARD_ZONES_CARDS_KPIS,
} from "../../utils/constants";
import HomeDivCard from "./HomeDivCard";

export default function HomeDashboardDiv({
  title_high,
  title_low,
  type,
  startDate,
  endDate,
}) {
  const { data: zonesCardsKpisData, isLoading: isLoadingZonesCardsKpisData } =
    useZonesCardsKpisData(startDate, endDate);
  const {
    data: collectionsCardsKpisData,
    isLoading: isLoadingCollectionsCardsKpisData,
  } = useCollectionsCardsKpisData(startDate, endDate);
  return (
    <>
      <Col xs={24} md={12} style={{ padding: 16 }}>
        <Card
          title={
            <Row justify="space-between" style={{ width: "100%" }}>
              <Col span={12} style={{ fontSize: 20, fontWeight: 600 }}>
                <ArrowUpOutlined style={{ color: "green", paddingRight: 10 }} />
                {title_high}
              </Col>
              <Col span={12} style={{ fontSize: 20, fontWeight: 600 }}>
                <ArrowDownOutlined style={{ color: "red", paddingRight: 10 }} />
                {title_low}
              </Col>
            </Row>
          }
          style={{
            height: "100%",
            textAlign: "center",
            backgroundColor: "#f0f1f5",
          }}
          styles={{
            header: {
              backgroundColor: "#d0d6e2",
              fontSize: 20,
              fontWeight: 500,
            },
          }}>
          <Row gutter={[16, 16]} style={{ width: "100%" }}>
            {type === "zones" &&
              HOME_DASHBOARD_ZONES_CARDS_KPIS.map((card, index) => (
                <HomeDivCard
                  key={index}
                  title={card?.title}
                  data={zonesCardsKpisData?.[card.group]?.[card.key]?.filter(
                    (item) =>
                      card.group === "occupation"
                        ? item.value !== 0
                        : card.group === "revenue" ||
                            card.group === "revenue_per_hour"
                          ? item.value !== 0
                          : true
                  )}
                  isLoading={isLoadingZonesCardsKpisData}
                  group={card.group}
                  cardKey={card.key}
                  icon={<BlockOutlined />}
                />
              ))}
            {type === "collections" &&
              HOME_DASHBOARD_COLLECTIONS_CARDS_KPIS.map((item, index) => (
                <HomeDivCard
                  key={index}
                  title={item.title}
                  data={collectionsCardsKpisData?.[item.group]?.[
                    item.key
                  ]?.filter((itemData) =>
                    item.group === "occupation"
                      ? itemData.value !== 0
                      : item.group === "revenue" ||
                          item.group === "revenue_per_hour"
                        ? itemData.value !== 0
                        : true
                  )}
                  isLoading={isLoadingCollectionsCardsKpisData}
                  group={item.group}
                  cardKey={item.key}
                  icon={<ShoppingOutlined />}
                />
              ))}
          </Row>
        </Card>
      </Col>
    </>
  );
}
